<div class="w-full h-full aspect43::p-10 p-5 overflow-y-scroll hide-bar">
  @if(dataParams.baseFilters){
  <div class="flex flex-wrap place-content-end gap-4">
    @for (baseFilter of dataParams.baseFilters; track $index) {
    <div>
      @if(baseFilter.type == 'select'){
      <std-select [currentValue]="listOfDataForBaseSelects[baseFilter.value].length == 1 ? listOfDataForBaseSelects[baseFilter.value][0] : null" [filterable]="true" customLabel="label-input" (onChangeValue)="changeBaseSelect($event, baseFilter)"
        [data]="listOfDataForBaseSelects[baseFilter.value]" [bindLabel]="baseFilter.bindLabel ?? 'label'"
        [bindValue]="baseFilter.bindValue ?? 'value'" [label]="t(baseFilter.label)"
        [placeholder]="t(baseFilter.placeholder)"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        customClassContaier="custom-select" class="w-[150px]" labelPosition="top"></std-select>} @if(baseFilter.type !==
      'select'){
      <std-input customInputClass="custom-input" customLabel="label-input" [type]="baseFilter.type" class="w-[150px]"
        labelPosition="top" [label]="t(baseFilter.label)" [placeholder]="t(baseFilter.placeholder)"></std-input>}
    </div>
    }
  </div>
  }
  <div class="grid md:flex my-4 items-center gap-8">
    <div class="flex flex-wrap gap-4 place-content-end w-full">
      @for (customAction of dataParams.customActions; track $index) {
      <std-button buttonClass="bg-primary !w-[200px] focus:bg-primary hover:bg-primary"
        (click)="generateCustomAction(customAction.component, null)">{{
        customAction.translateLabel
        ? t(customAction.label)
        : customAction.label
        }}</std-button>
      } @if(dataParams.canAddElement && ( maxItems == -3 || maxItems >
      totalItems)){<std-button (click)="currentItem = null; customForm = {};dataParams.usePageCreation?.route ? showCreationPage() : showModal = true" id="add-employee"
        class="!w-[200px] !h-auto" buttonClass="!h-auto bg-primary focus:bg-primary hover:bg-primary"
        size="sm">{{ t("add") }} {{dataParams.breadcrumb[0].title}}</std-button>}
    </div>

   @if(!dataParams.customFilters){ <std-click-outside [ngClass]="{ 'ml-auto': !dataParams.canAddElement }"
      (clickOutside)="showFilters = false"><std-tooltip
        classTooltip="!w-[330px] bg-tertiary shadow-xl right-0 m-0" position="left-bottom"
        [show]="showFilters"><svg (click)="showFilters = !showFilters" content style="fill: var(--primary)"
          class="h-[40px] w-[40px] cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
          viewBox="0 0 14 14">
          <path style="fill: var(--primary)"
            d="M7.21235 0.826019C3.62751 0.826019 0.710938 3.74259 0.710938 7.32744C0.710938 10.9123 3.62751 13.8289 7.21235 13.8289C10.7972 13.8289 13.7138 10.9123 13.7138 7.32744C13.7138 3.74259 10.7972 0.826019 7.21235 0.826019ZM8.21257 10.3281H6.21214C6.0795 10.3281 5.95229 10.2754 5.85851 10.1816C5.76472 10.0878 5.71203 9.96062 5.71203 9.82798C5.71203 9.69534 5.76472 9.56814 5.85851 9.47435C5.95229 9.38056 6.0795 9.32787 6.21214 9.32787H8.21257C8.34521 9.32787 8.47241 9.38056 8.5662 9.47435C8.65999 9.56814 8.71268 9.69534 8.71268 9.82798C8.71268 9.96062 8.65999 10.0878 8.5662 10.1816C8.47241 10.2754 8.34521 10.3281 8.21257 10.3281ZM9.7129 8.32765H4.71181C4.57917 8.32765 4.45197 8.27496 4.35818 8.18118C4.26439 8.08739 4.2117 7.96018 4.2117 7.82754C4.2117 7.69491 4.26439 7.5677 4.35818 7.47391C4.45197 7.38013 4.57917 7.32744 4.71181 7.32744H9.7129C9.84554 7.32744 9.97274 7.38013 10.0665 7.47391C10.1603 7.5677 10.213 7.69491 10.213 7.82754C10.213 7.96018 10.1603 8.08739 10.0665 8.18118C9.97274 8.27496 9.84554 8.32765 9.7129 8.32765ZM10.7131 6.32722H3.71159C3.57895 6.32722 3.45175 6.27453 3.35796 6.18074C3.26417 6.08695 3.21148 5.95975 3.21148 5.82711C3.21148 5.69447 3.26417 5.56727 3.35796 5.47348C3.45175 5.37969 3.57895 5.327 3.71159 5.327H10.7131C10.8458 5.327 10.973 5.37969 11.0667 5.47348C11.1605 5.56727 11.2132 5.69447 11.2132 5.82711C11.2132 5.95975 11.1605 6.08695 11.0667 6.18074C10.973 6.27453 10.8458 6.32722 10.7131 6.32722Z" />
        </svg>
        <div tooltip class="text-primary select-none !w-[330px] p-[15px] grid gap-[8px] lower-medium min-h-[350px] max-h-[50vh] overflow-y-scroll overflow-x-hidden custom-scrollbar-for-custom-filters">

          <div class="w-[300px]" (click)="$event.stopPropagation()">
            <std-select [filterable]="true" customLabel="label-input" [pipeTranslationLabelSelect]="t"
              customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
              customClassContaier="custom-select" class="w-[150px]" (onChangeValue)="
             addFilter($event)
              " labelPosition="top" [label]="t('filterFor')" [placeholder]="t('selectFilter')" [data]="filtersData"
              bindLabel="element" bindValue="element"></std-select>
          </div>

          @for (filter of filtersList; track $index) {
          <div class="items-center border-t-[1px] border-primary w-[300px]"
            (click)="$event.stopPropagation()">
        <div class="flex w-[300px]"> 
          
          <div  (click)="removeFilter($index)" class="!text-title text-left text-primary cursor-pointer w-[50%] font-semibold" style="font-size: var(--title) !important;">
              {{t(filter.s)}}
           
            </div>
          <div  (click)="removeFilter($index)" class="lowercase underline text-right text-medium text-primary opacity-50 cursor-pointer w-[50%]">
              {{t('delete')}}
            
            </div></div>  
          
            @if(hasOperator(filter?.s)){<std-select [filterable]="true" customLabel="label-input"
              customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
              customClassContaier="custom-select my-2.5" class="w-[150px]" (onChangeValue)="
                filter.o = getValue($event);
                filter.o === 10 ? initializeBetweenOperatorArray(filter) : null
              " [placeholder]="t('insertOperator')"
              [data]="filter.ops"></std-select>
            } @if(findElement(filter?.s)?.type !== 'select' && filter.o !== 10
            && filter.o !== 11 && filter.o !== 12){
            <std-input customInputClass="custom-input" customLabel="label-input" [type]="findElement(filter?.s)?.type"
              class="w-[150px]" [(ngModel)]="filtersList[$index].v" [placeholder]="t('insertValue')"
            ></std-input>} @if(findElement(filter?.s)?.type !== 'select' && filter.o ===
            10){
            <div class="flex gap-4">
              <std-input customInputClass="custom-input" customLabel="label-input" [type]="findElement(filter?.s)?.type"
                class="w-[100px]" [(ngModel)]="filtersList[$index].v[0]"
                [placeholder]="t('insertValue')"></std-input>
              <std-input customInputClass="custom-input" customLabel="label-input" [type]="findElement(filter?.s)?.type"
                class="w-[100px]" [(ngModel)]="filtersList[$index].v[1]"
                [placeholder]="t('insertValue')"></std-input>
            </div>
            } @if(findElement(filter?.s)?.type == 'select' && filter.o !== 10 &&
            filter.o !== 11 && filter.o !== 12){

            <std-select [filterable]="true" customLabel="label-input"
              customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
              customClassContaier="custom-select" class="w-[150px]"
              (onChangeValue)="filtersList[$index].v = getValue($event)" labelPosition="top" [label]="t('value')"
              [placeholder]="t('insertValue')" [data]="findElement(filter?.s)?.dataSelect?.length > 0 ? findElement(filter?.s)?.dataSelect : findElement(filter?.s)?.selectArray" [bindLabel]="findElement(filter?.s)?.dataSelect?.length > 0 ? 'element' : 'label'"
              [bindValue]="findElement(filter?.s)?.dataSelect?.length > 0 ? 'element' : 'value'"></std-select>
            }

            
          </div>
          }
          <div class="flex items-center mt-4 gap-2.5 w-[300px]">

            <std-button (click)="resetFilters()" class="ml-auto w-[150px]" type="tertiary"
              buttonClass="bg-tertiary focus:bg-tertiary hover:bg-tertiary !text-primary shadow-xl">{{ t("reset") }}</std-button>
            <std-button (click)="activeFilters()" class="ml-auto w-[150px]"
              buttonClass="bg-primary focus:bg-primary hover:bg-primary text-secondary my-4 md:my-0 shadow-xl'">{{ t("apply")
              }}</std-button>
          </div>
        </div>
      </std-tooltip>
    </std-click-outside>}
   
  </div>
   <div #customFiltersUniversalCrudContainer id="custom-filters-universal-curd-container" [ngClass]="{'hidden': !dataParams.customFilters}"></div>
  <div class="rounded-xl">
    <div class="w-full md:overflow-x-scroll custom-scroll mb-4">
     @if(!dataParams.customTable){ <std-table [tableTitle]="dataParams.tableTitle ? t(dataParams.tableTitle) : ''"
        class="hide-bar-all bg-secondary fix-table" [data]="dataTable" tableContainerClass="bg-secondary "
        headerClass=" bg-primary focus:bg-primary hover:bg-primary">
        @for (tableCol of dataParams.table; track $index) { @if(tableCol.table
        && tableCol.type !== 'image'){
        <span stdoutTableColumn width="calc(100% - 28px)" [label]="
            t('table.' + (tableCol.label ? tableCol.label : tableCol.element))
          ">
          <ng-template #dataTableCell let-item="item">
            @if(tableCol.type == 'color'){
            <div class="flex items-end gap-5">
              <div class="flex place-content-center mx-auto">
                <div class="size-[30px] border-[1px] !min-w-[30px] rounded-[8px] border-black" [style.background]="item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]"></div>
              </div>
            </div>
            }
            @if(tableCol.type == 'multiselect' &&  tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0 ){
              <div class="flex items-end gap-5">
                @for (itemMultiSelect of item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]; track $index) {
                  {{tableCol.multipleSelectArrayValue ? itemMultiSelect : itemMultiSelect[tableCol.bindLabelSelect ?? 'label']}} @if(!$last){|}
                }
              </div>
            }
            @if(tableCol.type !== 'date' && tableCol.type !== 'color' &&  tableCol.type !== 'multiselect'){
            <div class="flex items-end gap-5">
              {{
              (tableCol.translateValue
              ? t( (tableCol.prefixTranslateValue ? tableCol.prefixTranslateValue : '') + item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element])
              : item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]
              ) != 'undefined' ? (tableCol.translateValue
              ? t( (tableCol.prefixTranslateValue ? tableCol.prefixTranslateValue : '') + item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element])
              : item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]
              ):'Non presente'}}
            </div>
            } @if(tableCol.type == 'date'){
            <div class="flex items-end gap-5">
              {{
              getFormattedDate(
              item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]
              )
              }}
            </div>
            }
          </ng-template>
        </span>

        } @if(tableCol.table && tableCol.type === 'image'){
        <span stdoutTableColumn width="calc(100% - 28px)" [label]="t(tableCol.element)">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end h-[50px] gap-5">
              @if(
              item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element]
              ){<img class="max-h-[50px] mx-auto" [src]="
              item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element].includes('https://') ? item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element] :
                  (endPointBackend +
                  '/' +
                  item[(tableCol.tableElementToVisualize && tableCol.tableElementToVisualize.length > 0) ? tableCol.element + 'ToVisualize' : tableCol.element])
                " />
              }
            </div>
          </ng-template>
        </span>

        } }
        @if(dataParams.canEditElement || dataParams.canDeleteElement || dataParams.details || dataParams.customTableActions){<span stdoutTableColumn width="calc(100% - 28px)" [label]="t('actions')">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-5">
              @if(dataParams.canEditElement){<std-button (click)="setItemBefore(item);currentItem = item; initEdit()" size="xs"
                type="primary"
                buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto">
                <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" />
                </svg> </std-button>} @if(dataParams.canDeleteElement){<std-button
                (click)="showModalDelete = true; currentItem = item" size="xs" type="primary"
                buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto">
                <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                </svg> </std-button>}
              <std-button *ngIf="dataParams.details" (click)="showDetails(item)" size="xs" type="primary"
                buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto">
                <svg class="size-[16px]" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path class="fill-tertiary"
                      d="M10.0006 12.5004C11.3815 12.5004 12.5009 11.381 12.5009 10.0001C12.5009 8.61916 11.3815 7.49971 10.0006 7.49971C8.61966 7.49971 7.50021 8.61916 7.50021 10.0001C7.50021 11.381 8.61966 12.5004 10.0006 12.5004Z"
                      fill="white" />
                    <path class="fill-tertiary"
                      d="M19.1741 9.31995C18.1405 7.72151 16.7995 6.3637 15.2964 5.39299C13.6335 4.31799 11.7975 3.74963 9.98738 3.74963C8.32644 3.74963 6.69324 4.22424 5.13308 5.16018C3.54206 6.11448 2.10066 7.50862 0.848704 9.30354C0.70737 9.50639 0.629532 9.74669 0.62508 9.99388C0.620629 10.2411 0.689765 10.484 0.823704 10.6918C1.85534 12.3063 3.18308 13.666 4.66277 14.6235C6.32878 15.7028 8.12175 16.2496 9.98738 16.2496C11.812 16.2496 13.6518 15.686 15.3077 14.6199C16.81 13.6524 18.1483 12.2895 19.178 10.6778C19.3073 10.4748 19.3757 10.239 19.375 9.99828C19.3743 9.75761 19.3046 9.52218 19.1741 9.31995ZM10.0007 13.7496C9.25898 13.7496 8.53395 13.5297 7.91727 13.1176C7.30058 12.7056 6.81994 12.1199 6.53611 11.4347C6.25228 10.7495 6.17802 9.99548 6.32271 9.26805C6.46741 8.54062 6.82456 7.87243 7.34901 7.34798C7.87345 6.82354 8.54164 6.46638 9.26907 6.32169C9.9965 6.177 10.7505 6.25126 11.4357 6.53509C12.1209 6.81891 12.7066 7.29956 13.1187 7.91625C13.5307 8.53293 13.7507 9.25796 13.7507 9.99963C13.7495 10.9938 13.3541 11.947 12.6511 12.65C11.948 13.353 10.9949 13.7485 10.0007 13.7496Z"
                      fill="white" />
                  </g>
                </svg>
              </std-button>
              @for (customTableAction of dataParams.customTableActions; track
              $index) {
              <std-button (click)="
                  generateCustomAction(customTableAction.component, item)
                " size="xs" type="primary"
                buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-10"
                class="!h-10">
                <img [src]="customTableAction.icon" [class]="'size-[20px] ' + customTableAction.iconClass" />
              </std-button>
              }
            </div>
          </ng-template>
        </span>}
      </std-table>}
      <div #customTableUniversalCrudContainer id="custom-table-universal-crud-container" [ngClass]="{'hidden': !dataParams.customTable}"></div>
    </div>
  </div>
 @if(!dataParams.customPaginator && this.totalItems > 0){ <std-paginator [total]="this.totalPages" [current]="currentPage"
    (pageChange)="currentPage = $event; getTableData()">
    <div class="h-full w-auto my-auto text-black" arrowLeft>
      <</div>
        <div arrowRight class="h-full w-auto my-auto text-black">
          >
        </div>
  </std-paginator>}
    <div #customPaginatorUniversalCrudContainer id="custom-paginator-universal-crud-container" [ngClass]="{'hidden': !dataParams.customPaginator}"></div>
  @if(showModal){<std-modal cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showModal"
    [closeOnOutside]="false" (close)="showModal = false;customForm={}">
    <div class="text-tertiary text-title" header>
      {{ t(currentItem ? "modal.edit" : "modal.newElement") }}
    </div>
    <div content class="lower-medium">
      <div class="mt-4 grid gap-4">
        @for (dataForm of dataParams.table; track $index) {

        @if(currentItem &&
        dataForm.editable && (dataForm.type === 'color'||dataForm.type === 'text'||dataForm.type ===
        'number'||dataForm.type === 'textarea'||dataForm.type
        === 'email'||dataForm.type === 'password'||dataForm.type === 'url'||dataForm.type === 'tel')){<std-input
          customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
          [(ngModel)]="currentItem[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
            "></std-input>
        }



        @if(!currentItem && dataForm.creation && (dataForm.type === 'color'||dataForm.type === 'text'||dataForm.type ===
        'number'||dataForm.type === 'textarea'||dataForm.type
        === 'email'||dataForm.type === 'password'||dataForm.type === 'url'||dataForm.type === 'tel')){
        <std-input customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
          [(ngModel)]="customForm[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "></std-input>}

        @if(dataForm.creation && (dataForm.type
        === 'image' || dataForm.type
        === 'file')){
          <div>
          <div class="font-semibold label-input self-center">{{t(dataForm.element)}}</div>
          <div class="border-black border-[2px] rounded-md">
            
        <input class="p-2" type="file" (change)="manageFiles($event, dataForm)" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          " /></div></div>
        }
        @if(currentItem && dataForm.editable && dataForm.type == 'select'){
        <std-select [endpointData]="dataForm.selectDataEndpoint ?? ''" [filterable]="true" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event, dataForm)" [data]="
            listOfDataForSelects[dataForm.element] ?? dataForm.selectArray
          " [bindLabel]="dataForm.bindLabelSelect ?? 'label'" [bindValue]="dataForm.bindValueSelect ?? 'value'"
          customClassContaier="border-primary custom-select" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t('labels.' + (dataForm.label ? dataForm.label : dataForm.element))
          " [currentValue]="
            getCurrentValue(
              currentItem[dataForm.element],
              listOfDataForSelects[dataForm.element],
              dataForm
            )
          "></std-select>
        } @if(!currentItem && dataForm.creation && dataForm.type == 'select'){
        <std-select [endpointData]="dataForm.selectDataEndpoint ?? ''" [filterable]="true" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event, dataForm)" [data]="
            dataForm.selectArray ?? listOfDataForSelects[dataForm.element]
          " [bindLabel]="dataForm.bindLabelSelect ?? 'label'" [bindValue]="dataForm.bindValueSelect ?? 'value'"
          customClassContaier="border-primary custom-select" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t('labels.' + (dataForm.label ? dataForm.label : dataForm.element))
          "></std-select>}
          @if(currentItem && dataForm.editable && dataForm.type == 'multiselect'){
        <std-select direction="down" [endpointData]="dataForm.selectDataEndpoint ?? ''" [closeOnSelection]="false" customClassClose="size-4" [iconClose]="'../assets/xmark-solid.svg'"  [multiple]="true" [filterable]="true" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event, dataForm,true)" [data]="
            listOfDataForSelects[dataForm.element] ?? dataForm.selectArray
          " [bindLabel]="dataForm.bindLabelSelect ?? 'label'" [bindValue]="dataForm.bindValueSelect ?? 'value'"
          customClassContaier="border-primary custom-select" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t('labels.' + (dataForm.label ? dataForm.label : dataForm.element))
          " [currentValue]="
            getCurrentValue(
              currentItem[(dataForm.tableElementToVisualize && dataForm.tableElementToVisualize.length > 0) ? dataForm.element + 'ToVisualize' : dataForm.element],
              listOfDataForSelects[dataForm.element],
              dataForm,
              true
            )
          ">
        </std-select>
        } @if(!currentItem && dataForm.creation && dataForm.type == 'multiselect'){
        <std-select direction="down" [endpointData]="dataForm.selectDataEndpoint ?? ''" [closeOnSelection]="false" customClassClose="size-4" [iconClose]="'../assets/xmark-solid.svg'" [multiple]="true" [filterable]="true" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event, dataForm,true)" [data]="
            dataForm.selectArray ?? listOfDataForSelects[dataForm.element]
          " [bindLabel]="dataForm.bindLabelSelect ?? 'label'" [bindValue]="dataForm.bindValueSelect ?? 'value'"
          customClassContaier="border-primary custom-select" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t('labels.' + (dataForm.label ? dataForm.label : dataForm.element))
          "> </std-select>}

        @if(((!currentItem && dataForm.creation) || (currentItem && dataForm.editable)) && dataForm.type ===
        'date'){
        <div (click)="specialModalTimeToShow =   'date-'+dataForm.element">

          @if (!currentItem || customForm[dataForm.element]){<std-input customInputClass="custom-input"
            customLabel="label-input" class="pointer-events-none" [type]="'text'"
            [(ngModel)]="customForm[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "></std-input>}

          @if (currentItem && !customForm[dataForm.element]){<std-input customInputClass="custom-input"
            customLabel="label-input" class="pointer-events-none" [type]="'text'"
            [value]="currentItem[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "></std-input>}</div>

        @if(specialModalTimeToShow === 'date-'+dataForm.element){
        <div
          class="flex h-screen  !w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[9999] px-[10px]">
          <div class="bg-white rounded-[20px] p-4 max-w-[450px] border-primary border-[3px]">
            <std-mini-calendar (changeDate)="tempVariable = $event.formattedDate"
              [currentDate]="currentItem ? currentItem[dataForm.element] : null">
            </std-mini-calendar>
            <div footer class="mt-6 flex gap-4">
              <div class="w-full"> <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="specialModalTimeToShow = ''" class="w-[200px]">{{ t("modal.cancel") }}</std-button></div>
              <div class="w-full"> <std-button [ngClass]="{'opacity-35 pointer-events-none':(!tempVariable )}"
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="customForm[dataForm.element] = tempVariable ;tempVariable=null;specialModalTimeToShow = null"
                  class="w-[200px]">{{ t("modal.confirm") }}</std-button></div>
            </div>

          </div>
        </div>
        }

        }

        @if(((!currentItem && dataForm.creation) || (currentItem && dataForm.editable)) && dataForm.type ===
        'time'){
        <div (click)="specialModalTimeToShow =   'time-'+dataForm.element">

          @if (!currentItem || customForm[dataForm.element]){<std-input customInputClass="custom-input"
            customLabel="label-input" class="pointer-events-none" [type]="'time'"
            [(ngModel)]="customForm[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "></std-input>}

          @if (currentItem && !customForm[dataForm.element]){<std-input customInputClass="custom-input"
            customLabel="label-input" class="pointer-events-none" [type]="'time'"
            [value]="currentItem[dataForm.element]" [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "></std-input>}</div>
        @if(specialModalTimeToShow === 'time-'+dataForm.element){
        <div
          class="flex h-screen  !w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[9999]">
          <std-time-picker [showClock]="dataParams.showClock"
            [use24h]="dataParams.use24h" [startingTime]="currentItem ? currentItem[dataForm.element] : '00:00'"
            (changeDate)="tempVariable = $event.formattedTime">
            <div footer class="mt-6 flex gap-4">
              <div class="w-full"> <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="specialModalTimeToShow = ''" class="w-[200px]">{{ t("modal.cancel") }}</std-button></div>
              <div class="w-full"> <std-button
                  [ngClass]="{'opacity-35 pointer-events-none':currentItem && !tempVariable }"
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="customForm[dataForm.element] = tempVariable ? tempVariable : '00:00';tempVariable=null;specialModalTimeToShow = null"
                  class="w-[200px]">{{ t("modal.confirm") }}</std-button></div>
            </div>
          </std-time-picker>
        </div>
        }
        }



        }
      </div>
      <div class="mt-6 flex gap-4">
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="showModal = false;customForm={}"
          class="w-[200px]">{{ t("modal.cancel") }}</std-button>
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="
            isFormComplete()
              ? onModalConfirm(t)
              : showMessage(t('wrongForm'), 'error')
          " class="w-[200px]">{{ t("modal.confirm") }}</std-button>
      </div>
    </div>
  </std-modal>}

  <std-modal cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showModalDelete"
    [closeOnOutside]="false" (close)="showModalDelete = false">
    <div class="text-tertiary text-large" header>{{ t("modal.delete") }}</div>
    <div content class="custom-scrollbar">
      <div class="text-primary text-medium">{{ t("modal.confirmation") }}</div>
      <div class="mt-4 flex gap-4">
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="showModalDelete = false"
          class="">{{ t("modal.cancel") }}</std-button>
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="deleteElement(t)" class="">{{
          t("modal.confirm") }}</std-button>
      </div>
    </div>
  </std-modal>
  <div #customExtraComponentUniversalCrudContainer id="custom-extra-component-universal-crud-container" [ngClass]="{'hidden': !dataParams.customExtraComponent}"></div>
</div>